import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import {currency} from './utils/currency'
// Vue.filter("currency",currency);
import 'element-ui/lib/theme-chalk/index.css'
// import animated from 'animate.css'
// Vue.use(animated)
import {Carousel, CarouselItem, Dialog} from 'element-ui';
import {Swipe, SwipeItem} from 'vant';
import {Icon} from 'vant';

Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Icon)

Vue.use(Dialog)
Vue.use(Carousel)
Vue.use(CarouselItem)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
